function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import cn from 'classnames';
import React, { FC, HTMLAttributes } from 'react';
require("./Product.css");
var styles = {
  "ProductRoot": "Product-module-ProductRoot_24E",
  "ProductHeader": "Product-module-ProductHeader_zOD",
  "ProductBody": "Product-module-ProductBody_hFy",
  "ProductFooter": "Product-module-ProductFooter_3Rv",
  "Skeleton": "Product-module-Skeleton_1Bx",
  "Column": "Product-module-Column_2-x",
  "SkeletonTitle": "Product-module-SkeletonTitle_3MD",
  "SkeletonText": "Product-module-SkeletonText_3UG",
  "Row": "Product-module-Row_2AA",
  "SkeletonFullWidth": "Product-module-SkeletonFullWidth_229",
  "SkeletonSizeX": "Product-module-SkeletonSizeX_t04",
  "SkeletonSizeM": "Product-module-SkeletonSizeM_3qs",
  "SkeletonSizeL": "Product-module-SkeletonSizeL_lr0",
  "SkeletonSizeXL": "Product-module-SkeletonSizeXL_1lK",
  "SkeletonImage": "Product-module-SkeletonImage_3M2",
  "SkeletonTextSmall": "Product-module-SkeletonTextSmall_3r4",
  "SkeletonPrice": "Product-module-SkeletonPrice_3gb",
  "SkeletonBonus": "Product-module-SkeletonBonus_1tB",
  "SkeletonButton": "Product-module-SkeletonButton_s5a"
};
export const ProductHeader = ({
  children,
  className,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: cn(styles.ProductHeader, className)
  }), children);
};